module.exports = __webpack_public_path__ + "img/block6.cfaa87eb.svg";